import React, { Component } from 'react';

import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import {  Grid } from '@material-ui/core';

import Reicing from '../reicing/Reicing';
import SkidExchange from '../skidExchange/SkidExchange';
import PayByHouseBill from '../payByHouseBill/PayByHouseBill';
import BupBreakdownLD3 from '../bupBreakdownLD3/BupBreakdownLD3';
import BupBreakdownLD7 from '../bupBreakdownLD7/BupBreakdownLD7';
import BupBreakdownMain from '../bupBreakdownMain/BupBreakdownMain';

import AddServicesUnits from '../../../../models/AddServicesUnits';

import commonAddServiceStyles from './commonAdditionalService.module.css';
import commonStyles from '../../../common/common.module.css';
import { formatCurrency } from '../../../../utils/currencyFormatter';
import BupBreakdown20ft from '../bupBreakdown20ft/BupBreakdown20ft';
import BupBreakdownQ7 from '../bupBreakdownQ7/BupBreakdownQ7';
import LabelFreight from '../labelFreight/LabelFreight';

const TEXT_FIELD_PADDINGS: string = '8px 12px';
const styles = (theme: any) => ({

});

interface CommonAdditionalServiceProps {
  classes: any;
  serviceDetails: AddServicesUnits;
  isNumber: Function;
  error: boolean;
  value: string;
  total: number;
  bupId?: string;
  additionalInformation: string;
  handleChange: any;
  allowedService: boolean;
  isServiceInCart: boolean;
};

interface CommonAdditionalServiceState {};

class CommonAdditionalService extends Component<CommonAdditionalServiceProps, CommonAdditionalServiceState>  {

  render () {

    const { classes, serviceDetails, isNumber, bupId } = this.props;

    return (
      <FormControl fullWidth={ true }>
          <Grid container alignItems="flex-end" className={ commonAddServiceStyles.gridContainer }>
            <Grid item md={4} sm={4} xs={12} direction="row" className={ commonAddServiceStyles.gridItem }>
              { serviceDetails.cost_per_hawb_usd && <PayByHouseBill serviceDetails={ serviceDetails } /> }
    
              { serviceDetails.cost_per_kg_usd && <Reicing serviceDetails={ serviceDetails } /> }

              { serviceDetails.cost_usd && bupId === '3' && <BupBreakdownLD3 serviceDetails={ serviceDetails } /> }

              { serviceDetails.cost_usd && bupId === '7' && <BupBreakdownLD7 serviceDetails={ serviceDetails } /> }

              { serviceDetails.cost_usd && bupId === 'main' && <BupBreakdownMain serviceDetails={ serviceDetails } /> }

              { serviceDetails.cost_usd && bupId === 'skid' && <SkidExchange serviceDetails={ serviceDetails } /> }
              
              { serviceDetails.cost_usd && bupId === '20' && <BupBreakdown20ft serviceDetails={ serviceDetails } /> }
              
              { serviceDetails.cost_usd && bupId === 'q7' && <BupBreakdownQ7 serviceDetails={ serviceDetails } /> }
              
              { serviceDetails.cost_per_box_usd && bupId === 'label' && <LabelFreight serviceDetails={ serviceDetails } /> }

              <span></span>
            </Grid>

            <Grid item md={4} sm={4} xs={12} direction="row" className={ commonAddServiceStyles.gridItem }>
              <label className={ commonStyles.inputLabel }> Enter Nbr Units<span className={ commonAddServiceStyles.asterisk }>*</span> </label>
              <TextField
                error={ this.props.error }
                onChange={
                  (event) => {
                    isNumber(event.target.value);
                    this.props.handleChange(event, 'inputValue')
                  }
                }
                label=""
                variant="outlined"
                value={ this.props.value }
                inputProps={{ classes: { notchedOutline: classes.overrideBorder },
                              style: { padding: TEXT_FIELD_PADDINGS }
                            }}
                InputLabelProps={{ shrink: true }}
                disabled={ !this.props.allowedService }
                fullWidth
              />
            </Grid>
            
            <Grid item md={4} sm={4} xs={12} direction="row" className={ commonAddServiceStyles.gridItem }>
              <label className={ commonStyles.inputLabel }>Total Cost </label>
              <TextField
                disabled
                label=""
                value={ formatCurrency(this.props.total, 2, '$') }
                variant="outlined"
                inputProps={{ classes: { notchedOutline: classes.overrideBorder },
                              style: { padding: TEXT_FIELD_PADDINGS }
                            }}                
                InputLabelProps={{ style: { fontWeight: 'bold' } }}
                fullWidth
              />
            </Grid>
          </Grid>
  
        <div className= { ` ${ commonAddServiceStyles.addInfoWrapper } ${ commonStyles.inputLabelWrapper }` }>
          <label className={ commonStyles.inputLabel }>  Additional information to GHA </label>
          <TextField
            fullWidth={ true }
            id="outlined-disabled"
            label=""
            variant="outlined"
            onChange={ (event) => this.props.handleChange(event, 'additionalInformation') }
            value={ this.props.additionalInformation }
            InputProps={{ classes: { notchedOutline: classes.overrideBorder },
                          style: { padding: TEXT_FIELD_PADDINGS } }}
            InputLabelProps={{ shrink: true }}
            disabled={ !this.props.allowedService && !this.props.isServiceInCart }
          />
        </div>
      </FormControl>
    );
  }
}

export default withStyles(styles)(CommonAdditionalService);